// extracted by mini-css-extract-plugin
export default {"body-card":"BodyCard_body-card__0DLNI","placeholder-body-card":"BodyCard_placeholder-body-card__TR8cG"};